<template>
  <div
    class="form-search-customer bordered-bottom"
    style="text-align: left"
    @click="$router.push({ name: 'searchCustomer', query: { fromForm: true, fromView: $route.name } })"
  >
    <label
      class="label"
      @click="displayChangeClient = true"
    >{{ label }}*</label>
    <div
      v-if="$customer.currentCustomer.id_customer"
      class="main-form"
    >
      <div class="segments">
        {{ $customer.currentCustomer.firstname }} {{ $customer.currentCustomer.lastname }}
      </div>
      <div class="edit-values">
        <img
          src="@/assets/icons/edit.png"
          alt="change customer"
        >
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FormSearchCustomer',
  props: {
    label: String,
    placeholder: String,
    name: String
  },
  data() {
    return {
      displayChangeClient: false
    }
  }
}
</script>

<style lang="scss" scoped>
  .form-search-customer {
    margin: 7px 0;
    display: flex;
    flex-direction: column;
    width: 100%;

    .label {
      padding-left: 12px;
      color: #777;
      font-size: 0.75rem !important;
    }

    .main-form {
      display: flex;
      padding-left: 12px;

      .segments {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        width: 100%;
      }

      .edit-values {
        padding: 5px;
        place-self: center center;

        > img {
          height: 1rem;
        }
      }
    }
  }
</style>
